import { render, staticRenderFns } from "./between.vue?vue&type=template&id=5aaf224a&"
import script from "./between.vue?vue&type=script&lang=js&"
export * from "./between.vue?vue&type=script&lang=js&"
import style0 from "./between.vue?vue&type=style&index=0&id=5aaf224a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports